import { render, staticRenderFns } from "./ServiceUpdate.vue?vue&type=template&id=df626a7c&scoped=true"
import script from "./ServiceUpdate.vue?vue&type=script&lang=js"
export * from "./ServiceUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df626a7c",
  null
  
)

export default component.exports